import axios from 'axios';
import { IDivision } from '../../../@types/model/masterData/division/division';
import { IDivisionUpsert } from '../../../@types/model/masterData/division/divisionUpsert';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';

export default class DivisionHttpService {
    public static getList = async (
        lastSyncedTimeUnix : number,
        divisionIds : Array<number> | null,
        signal ?: AbortSignal) : Promise<Array<IDivision>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/Division/GetList`, {
            params: {
                lastSyncedTimeUnix,
                divisionIds,
            },
            paramsSerializer: {
                indexes: null
            },
            signal
        });

        return result.data;
    }


    public static upsert = async (upsert : IDivisionUpsert, type : UpsertTypeEnum) : Promise<IDivision> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/Division/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/Division/Delete`, {
            params: { id },
        });
    }
}